import React, { Component } from "react";
import { setMenuTopIndex, setMenuLeftContent, setMenuLeftIndex } from "../../../redux/actions/menuActions";
import connect from "react-redux/es/connect/connect";
import axios from "axios";
import MenuAdmin from "../Menu";
import moment from "moment";
const responseLogLocal = require("./log.json");
class Home extends Component {
  state = {
    entry: undefined,
    userEmail: undefined,
    userId: undefined
  };
  async componentDidMount() {
    this.props.setMenuTopIndex("admin");
    this.props.setMenuLeftContent(MenuAdmin);
    this.props.setMenuLeftIndex("logs");
    const token = await localStorage.getItem("access_token");
    const currentVisitId = this.props.match.params.id;
    if (!currentVisitId) {
      this.props.history.push("/log");
    }
    try {
      const response = await axios.post(
        process.env.REACT_APP_API + "/api/logs",
        { match: { _id: currentVisitId } },
        {
          headers: {
            Authorization: token
          }
        }
      );
      const responseLog =
        Array.isArray(response.data) && response.data.length === 1 ? response.data[0] : responseLogLocal;

      await this.setState({ userId: responseLog.user_id, entry: responseLog });
    } catch (e) {
      console.log(e);
      const responseLog = responseLogLocal;
      await this.setState({ userId: responseLog.user_id, entry: responseLog });
    }

    const responseUser = await axios.post(
      process.env.REACT_APP_API + `/api/users/`,
      { match: { _id: `${this.state.userId}` } },
      {
        headers: {
          Authorization: token
        }
      }
    );
    let email = "email inconnu";
    if (Array.isArray(responseUser.data) && responseUser.data.length === 1) {
      email = responseUser.data[0].email;
    }
    await this.setState({
      userEmail: email
    });
  }

  render() {
    const { entry, userEmail } = this.state;
    return this.state.entry && Array.isArray(this.state.entry.data) ? (
      <div>
        <div>titre : {entry.title}</div>
        <div>msg : {entry.msg}</div>
        <div>user_id : {entry.user_id}</div>
        <div>email : {userEmail}</div>
        <div>date : {moment(entry.created_at).format("YYYY.MM.DD HH:mm:ss")}</div>
        {this.state.entry.data.map((log, i) => {
          let messageArray;
          try {
            messageArray = log && log.msg ? log.msg : [];
          } catch (e) {
            messageArray = [];
          }
          let primary = messageArray[0];

          let secondary = messageArray[1];
          let dataStringify = messageArray[2] ? JSON.stringify(messageArray[2]) : null;
          let endStringify = messageArray[3] ? JSON.stringify(messageArray[3]) : null;
          dataStringify = endStringify ? dataStringify + "--" + endStringify : dataStringify;
          let data =
            dataStringify && dataStringify.length && dataStringify.length > 3000
              ? `${dataStringify.substring(0, 3000)}...`
              : dataStringify;

          return (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: primary === "Login" ? 20 : null,
                paddingBottom: primary === "Login" ? 20 : null,
                borderBottomWidth: primary === "Login" ? 1 : 0,
                borderBottomColor: primary === "Login" ? "black" : null,
                borderBottomStyle: "solid"
              }}
              key={i}
            >
              <div
                style={{
                  flex: 1
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    divAlign: "center",
                    color: log.level === 3 ? "red" : "black"
                  }}
                >
                  {log.level}
                </div>
              </div>
              <div style={{ flex: 3, fontSize: 10, color: log.level === 3 ? "red" : "black" }}>
                {moment(log.date).format("YYYY.MM.DD HH:mm:ss")}
              </div>
              <div
                style={{
                  flex: 8,
                  fontSize: 10,
                  color: log.level >= 3 ? "red" : "black"
                }}
              >{`${primary} > ${secondary} > ${data}`}</div>
            </div>
          );
        })}
      </div>
    ) : (
      <div>Pas de log disponible</div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftContent: data => {
      dispatch(setMenuLeftContent(data));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/admin/logs/Preview.log.js